import React from "react";
import ChooseDestination from "./ChooseDestination";
import SubMenuItem from "./SubMenuItem";
import DestinationItem from "./DestinationItem";
import { DestinationOption, DestinationType } from "../../dataTypes";


// ** import css
import "./menu.css";
import useIsMobile from "../../hooks/useIsMobile.hook";
import MobileSubMenu from "./MobileSubMenu";

type MenuProps = {
  destinations: DestinationType[];
  handleDestinationClick: (id: number) => void;
  selectedDestination : DestinationOption
};

const Menu = ({ destinations, handleDestinationClick, selectedDestination }: MenuProps) => {

  const { isMobile } = useIsMobile();

  // this gets all the configuration options per click of Destination and stores it in obj
  const showMenuOptions = (): [string, unknown][] | null => {
    let doesIt = selectedDestination.hasOwnProperty( 'options' )
    if ( doesIt ) {
        let obj = Object.entries(selectedDestination.options as {})
        return obj
    } else {
        return null
    }
  }

  const renderMobileMenu = (): JSX.Element => (
    <div className="mobileMenu" style={{paddingTop: '21px'}}>
      <ChooseDestination>
        {destinations.map((item) => (
          <DestinationItem
            key={item.id}
            destination={item}
            onItemClick={() => handleDestinationClick(item.id)}
          />
        ))}
      </ChooseDestination>
      <MobileSubMenu subMenuItems={showMenuOptions()} />
      
    </div>
  )

  const renderDesktopMenu = (): JSX.Element => (
    <div className="destinationMainMenu">
      <ChooseDestination>
        {destinations.map(
          (item: { id: number; destination: string; selected: boolean }) => {
            return (
              <DestinationItem
                key={item.id}
                destination={item}
                onItemClick={() => handleDestinationClick(item.id)}
              />
            );
          }
        )}
      </ChooseDestination>
      
      <div className='subMenuContainer'>
        {
                showMenuOptions()?.map( (menu, index) => {
                    const [optionname, arr] = menu
                    return (
                    <SubMenuItem 
                      title={optionname}
                      index={index}
                      options={arr as string[]}
                      key={index}
                    />
                      
                    )
                })

        }
     </div>
    </div>
  )

  return isMobile ? renderMobileMenu() : renderDesktopMenu();
};

export default Menu;
